import React from "react";
import profile from "../../../../assets/img/Home/profile.png";
import eye from "../../../../assets/img/icons/eye.svg";
import heart from "../../../../assets/img/icons/heartred.svg";
import message from "../../../../assets/img/icons/message-text.svg";
import img from "../../../../assets/img/blog/Rectangle 99.png";
import clock from "../../../../assets/img/icons/clockcopy.svg";
const AdminBlogCard = () => {
  return (
    <div className="AdminBlogCard">
     <div className="flex justify-between">
   <div >
   <div className="profle-card flex items-center gap-[10px]">
        <img src={profile} />
        <div className="">
          <p className="profle-card--name">اشکان قاسمی</p>
          <p className="profle-card--date">منتشر شده در 29 مهر 1401</p>
        </div>
      </div>
      <h3>بهترین مقاصد برای سفر در فصل پاییز</h3>
      <p className="AdminBlogCard--des">
        سفر در پاییز یک مسیر رنگارنگ از زرد و سرخ و نارنجی‌ها در مقاصد گردشگری
        است که از هیاهوی تابستان به سکوت و خلوتی پاییز رسیده‌اند.
      </p>

   </div>
   <div>
     <img src={img} className='AdminBlogCard--img'/>
   </div>
     </div>

      <div className="flex justify-between items-center mt-[37px]">
        <div className="flex gap-[17px] items-center">
          <div className="BlogCard-tag">سفر به کجا</div>
          <div className="flex items-center">
            <img src={clock} className='ml-[10px]'/>
            <p className="BlogCard-timetoread">12 دقیقه زمان مطالعه</p>
          </div>
        </div>
        <div className="flex gap-[12px] itemx-center">
          <div className="BlogCard-infobox bg-[#DEE5F7] text-[#2058E9] flex items-center">
            <img src={eye} className='ml-[7px]'/>
            <p  className="Danafont">32</p>
          </div>
          <div className="BlogCard-infobox BlogCard-infobox-red text-[#F10840] flex items-center">
            <img src={heart} className='ml-[7px]'/>
            <p className="Danafont">21</p>
          </div>
          <div className="BlogCard-infobox bg-[#DEF7F7] text-[#00A6A6] flex items-center">
            <img src={message} className='ml-[7px]'/>
            <p  className="Danafont">32</p>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default AdminBlogCard;
